import { Component } from '@angular/core';

@Component({
  selector: 'ngx-footer',
  styleUrls: ['./footer.component.scss'],
  template: `
      <kl-dashboard-copyright></kl-dashboard-copyright>
  `,
})
export class FooterComponent {
}
